<template>
  <b-row>
    <b-col>
      <b-row>
        <div class="col-lg-12" v-if="apiAccess.length > 0">
          <b-table
              ref="apiAccessTable"
              hover
              :items="apiAccess"
              :fields="fields"
              bordered
              striped
          >
            <template #cell(actions)="access">
              <ul class="list-inline font-size-20 mb-0">
                <li class="list-inline-item px-2">
                  <div
                      v-b-tooltip.hover
                      title= "Token anschauen"
                      @click="openApiToken(access.item.id)"
                      class="tenant--function tenant--function__modify-tenant"
                  >
                    <i class="bx bxs-show" aria-hidden="true"></i>
                  </div>
                </li>
                <li class="list-inline-item px-2">
                  <div
                      v-b-tooltip.hover
                      title= "API-Access löschen"
                      @click="deleteApiAccess(access.item.id)"
                      class="tenant--function tenant--function__modify-tenant"
                  >
                    <i class="bx bx-trash" aria-hidden="true"></i>
                  </div>
                </li>
              </ul>
            </template>
          </b-table>
        </div>
      </b-row>
      <div class="col-lg-12">
        <api-access-create :id="id"/>
      </div>
      <b-modal id="tokenModal" title="BootstrapVue">
        <b-table
            ref="apiTokenTable"
            hover
            :items="fetchApiToken"
            :fields="fields2"
            bordered
            striped
        >
        </b-table>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { adminService } from "@/helpers/services/admin/adminService";
import ApiAccessCreate from "@/router/views/admin/api-consumers/api-access/api-access-create";
import i18n from "@/i18n";

export default {
  components: {ApiAccessCreate},
  props: {
    id: {
      type: String,
      required: true
    },
  },
  name: "api-access-list",
  data() {
    return {
      apiAccess: [],
      fields: [
        {"apiConsumerName": "Api Consumer Name"},
        {"companyName": "Tenant Name"},
        {"isActive": "Aktiv"},
        { key: "actions", label: i18n.t("actions") }
      ],
      fields2: [
        {"id": "Token"},
        {"isActive": "Aktiv"},
      ],
      currentApiAccessId: null,
      apiToken: []
    }
  },
  created() {
    adminService.fetchApiAccessList(this.id)
    .then(t => this.apiAccess = t);
  },
  methods: {
    fetchApiToken() {
      return adminService.fetchApiToken(this.currentApiAccessId);
    },
    openApiToken(apiAccessId) {
      this.currentApiAccessId = apiAccessId;
      this.$bvModal.show('tokenModal');
    },
    deleteApiAccess(apiAccessId) {
      adminService.deleteApiAccess(apiAccessId);
    }
  }
}
</script>

<style>

</style>